import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { DatePipe } from "@angular/common";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { AppMainService } from "src/app/app-main.service";
import { ProductsService } from "src/app/inventory/products/products.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { CustomAttributeFieldType, TaxCountry, TemplateType, SOChannel } from "src/app/inventory/sales-order/constants/constants";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";
import { ApprovalTypeInfo } from "src/app/modules/shared/model/approval/approval-info";
import { Status } from "../../models/status";
import { ApprovalType } from "../../enums/approval/approval.enum";
import { Router } from "@angular/router";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: "app-estimates-overview",
    templateUrl: "./estimates-overview.component.html",
    styleUrls: ["./estimates-overview.component.scss"],
})
export class EstimatesOverviewComponent implements OnInit, OnChanges {
    @Input() estimatesDetails;
    @Input() showEstimateVoidMsg;
    @Input() templates;
    @Input() glTabvisibleFrom;
    @Input() visibleFromModule;
    @Output() onAccountView = new EventEmitter();
    @Output() refreshEmitter = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    fieldTypes = CustomAttributeFieldType;
    cols = 0;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    today = new Date();
    voidDate: string;
    allCustomAttributes = [];
    allModules = [];
    orderObjId;
    billingAddress;
    billingAddressContact;
    purchaseList = [];
    discounts = [];
    showTaxBasedSplitView = false;
    isStateMatched = false;
    estimateDetails: any = null;
    totalAmount: number = 0;
    productsTotalAdditionalAmount: number = 0;
    filteredSection: any[] = [];
    soChannel = SOChannel;
    sanitizedHtml: SafeHtml;

    //Inventory Overview
    transactionNames = TransactionNames;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    /** Approval */
    displayViewApproval: boolean = false;
    approvalTypeInfo: ApprovalTypeInfo;

    //stages
    estimateStages1 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Presented" },
        { id: 3, name: "Accepted" },
        { id: 4, name: "Convert to SO" },
    ];
    estimateStages2 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Presented" },
        { id: 3, name: "Accepted" },
        { id: 4, name: "Convert to Invoice" },
    ];
    estimateStages3 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Presented" },
        { id: 3, name: "Declined" },
    ];
    estimateStages4 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Review Required" },
        { id: 3, name: "Rejected" },
    ];
    estimateStages5 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Review Required" },
        { id: 3, name: "Approved" },
        { id: 4, name: "Presented" },
        { id: 5, name: "Declined" },
    ];
    estimateStages6 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Review Required" },
        { id: 3, name: "Approved" },
        { id: 4, name: "Presented" },
        { id: 5, name: "Accepted" },
        { id: 6, name: "Convert to SO" },
    ];
    estimateStages7 = [
        { id: 1, name: "Draft" },
        { id: 2, name: "Review Required" },
        { id: 3, name: "Approved" },
        { id: 4, name: "Presented" },
        { id: 5, name: "Accepted" },
        { id: 6, name: "Convert to Invoice" },
    ];
    displayChangeStatus = false;
    //when draft
    statusOption1 = [
        { id: 1, name: "Review Required" },
        { id: 2, name: "Presented" },
        { id: 3, name: "Convert to SO" },
        { id: 4, name: "Convert to Invoice" },
    ];
    //when review required
    statusOption2 = [
        { id: 1, name: "Approved" },
        { id: 2, name: "Rejected" },
    ];
    //when approved
    statusOption3 = [
        { id: 1, name: "Presented" },
        { id: 2, name: "Convert to SO" },
        { id: 3, name: "Convert to Invoice" },
    ];
    //when presented
    statusOption4 = [
        { id: 1, name: "Accepted" },
        { id: 2, name: "Declined" },
    ];
    //when accepted
    statusOption5 = [
        { id: 1, name: "Convert to SO" },
        { id: 2, name: "Convert to Invoice" },
    ];

    // currency
    baseCurrency: any;
    orgCurrency = [];
    savedCurrencyExchangeRate: any;
    savedCurrencyUnit: any;

    transactionTypeIds = AccountsTransactionType;
    glApiCall: boolean = false;
    estimateId: number;

    constructor(
        public app: AppMainComponent,
        private datePipe: DatePipe,
        private utilityService: UtilityService,
        private appMainService: AppMainService,
        private productsService: ProductsService,
        private salesOrderService: SalesOrderService,
        private importService: ImportserialService,
        private router: Router,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.estimatesDetails && changes.estimatesDetails.currentValue) {
            this.estimateId = this.estimateDetails?.id
            this.estimatesDetails = changes.estimatesDetails.currentValue;
            this.prepareEstimatesDetailsData();
        }
        this.getColsCount();
        this.voidDate = this.datePipe.transform(Date.now(), "MM-dd-yyyy");
    }

    ngOnInit() {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.getBaseCurrency();
        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
        this.getAllCustomAttributes();
        // this.getAllGroup();
        this.utilityService.getFilteredSectionsByType(0).subscribe((res) => {
            this.filteredSection = res;
        });

        this.salesOrderService.getAllOrdersChannel("Orders Template").subscribe((configs) => {
            let allTemplates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.templates = allTemplates?.filter((t) => t.typeId == TemplateType.Estimate)[0];
        });
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }
    prepareEstimatesDetailsData() {
        this.salesOrderService.getDiscounts(false).subscribe((res) => {
            this.discounts = res;
            this.parseEstimatesDetailsData();
        });
    }

    parseEstimatesDetailsData() {
        this.estimatesDetails.estimateDate = this.app._showDateTimeWithZone(this.estimatesDetails.estimateDate);
        this.estimatesDetails.expiryDate = this.app._showDateTimeWithZone(this.estimatesDetails.expiryDate);
        this.templates = this.estimatesDetails && this.estimatesDetails.configJSON ? JSON.parse(this.estimatesDetails.configJSON) : this.templates;
        this.customFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
        this.billingAddress = this.estimatesDetails.account.accountAddresses.filter((d) => d.addressId == this.estimatesDetails.billingAddressId)[0];
        this.billingAddressContact = this.estimatesDetails?.contact;
        this.purchaseList = this.utilityService.prepareEstimateOverviewProductsList(this.estimatesDetails, this.discounts);
        this.savedCurrencyExchangeRate = Number(this.estimatesDetails.exchangeRate);
        this.savedCurrencyUnit = this.estimatesDetails.account?.currencyUnit;

        // populate saved custom field data
        Object.keys(this.customFields).forEach((key) => {
            const dataArr = this.customFields[key];
            if (dataArr && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const filteredCustom = this.estimatesDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                    if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                        element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                        element.value = filteredCustom.values.name;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el.name);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                });
            }
        });

        this.estimateDetails = _.cloneDeep(this.estimatesDetails);
        this.checkCountryToShowSplitView();
        this.calculateTotalAmount();
        this.calculateProductsTotalAdditionalAmount();
    }
    calculateTotalAmount() {
        this.totalAmount = this.estimateDetails?.estimateProducts?.reduce((total, item) => total + Number(item?.totalAmount), 0);
    }

    calculateProductsTotalAdditionalAmount() {
        const getAdditionalAmount = (item) => {
            let total = item?.product?.typeId == 4 ? 0 : Number(item?.additionalAmount) || 0;
            if (item?.estimateBundleDetail && item.estimateBundleDetail?.length > 0) {
                total += item.estimateBundleDetail.reduce((sum, bundleItem) => {
                    return sum + getAdditionalAmount(bundleItem);
                }, 0);
            }
            return total;
        };
    
        this.productsTotalAdditionalAmount = this.estimateDetails?.estimateProducts?.reduce((total, item) => {
            return total + getAdditionalAmount(item);
        }, 0) || 0;
    }

    checkCountryToShowSplitView() {
        if (this.billingAddress?.address?.countryId == TaxCountry.India) {
            if (this.billingAddress?.address?.countryId == this.estimateDetails?.warehouse?.address?.countryId && this.billingAddress?.address?.state?.name?.toLowerCase() == this.estimateDetails?.warehouse?.address?.state?.name?.toLowerCase()) {
                this.isStateMatched = true;
            } else {
                this.isStateMatched = false;
            }
            this.showTaxBasedSplitView = true;
        } else {
            this.showTaxBasedSplitView = false;
        }
    }

    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService.getAllCustomFields(this.orderObjId).then((fields) => {
            this.allCustomAttributes = _.cloneDeep(fields);
            this.appMainService.isHideSpinner("loadCustomAttributes");
        });
    }

    getAllGroup() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.getAllDiscountByGroupId(disGroupId);
        });
    }

    getAllDiscountByGroupId(groupId) {
        this.salesOrderService.getGroupById(groupId).subscribe((res) => {
            this.discounts = res;
        });
    }

    getTaxAmount(b, uomValue?) {
        let amount = 0;
        if (b.tax && b.tax.taxRate) {
            amount = b.pickedQty > 0 ? (Number(b.tax.taxRate) / 100) * (Number(b.pickedQty) * Number(uomValue) * Number(b.pricePerProduct)) : (Number(b.tax.taxRate) / 100) * (Number(b.quantity) * Number(uomValue) * Number(b.pricePerProduct));
        }
        return amount;
    }

    getFormattedData(field) {
        if (field && field?.value && field?.value.length > 0) {
            let d = "";
            field.value.forEach((f) => {
                d += f.name + ",";
            });
            return d.substring(0, d.length - 1);
        } else {
            return "";
        }
    }

    getColsCount() {
        this.cols = 0;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }
    }

    onAccountViewClick(e) {
        this.onAccountView.emit({ id: e?.account?.id ?? 0, channelId: e?.channelId });
    }

    navigateToInvoice(e) {
        this.inventoryOverviewRefId = e.invoiceId;
        this.inventoryOverviewRefNumber = e.invoiceNo;
        this.inventoryOverviewModule = TransactionNames.Invoice;
        this.displayInventoryOverview = true;
    }
    navigateToSalesOrder(e) {
        this.inventoryOverviewRefId = e.salesOrderId;
        this.inventoryOverviewRefNumber = e.salesOrderNo;
        this.inventoryOverviewModule = TransactionNames.SalesOrder;
        this.displayInventoryOverview = true;
    }
    navigateToOpportunity(e) {
        this.router.navigate(["/opportunities"], {
            queryParams: {
                id: e?.opportunityId,
                module: "Opportunity",
                channelId: 1, // todo: need to change
                statusId: 1,
                globalSearch: true,
                data: e?.opportunityNo,
            },
        });
    }

    closeViewPopup() {
        this.displayInventoryOverview = false;
    }

    // find section by code
    getFilteredSectionsByType(code: string): string {
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    /** Approval Details */
    showApprovalDetails(estimate) {
        this.approvalTypeInfo = {
            approvalType: ApprovalType.EstimateApproval,
            approvalTypeId: estimate.id,
            approvalTypeNumber: estimate.number,
            status: "1",
        };
        this.displayViewApproval = true;
    }
    handleApprovalStatus(isUpdate: boolean) {
        if (isUpdate) {
            this.refreshEmitter.emit({ refresh: true });
        }
    }

    changeStatus() {
        this.displayChangeStatus = true;
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }

    getSanitizedHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
